import { useMutation } from 'react-query';

import { useCompanyId } from 'modules/app/hooks/useCompanyId';
import { apiUrl } from 'src/core/utils/api';

export const useDeletePayableRulesMutation = () => {
  const companyId = useCompanyId();
  return useMutation(
    ['bookkeeping', 'automation', 'payable-rules', 'delete'],
    async ({ payableRuleIds }: { payableRuleIds: string[] }): Promise<void> => {
      const payableRuleIdsStringified = payableRuleIds.join(',');
      const response = await fetch(
        apiUrl(
          `/bookkeeping/automation/payable-rules?ids=${payableRuleIdsStringified}`,
          companyId,
        ),
        {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include',
        },
      );

      if (!response.ok) {
        throw new Error(
          `Failed to delete payable rules ids=${payableRuleIdsStringified}`,
        );
      }
    },
    {
      retry: false,
    },
  );
};
